import { render, staticRenderFns } from "./CompactPagination.vue?vue&type=template&id=99561ca8&scoped=true"
import script from "./CompactPagination.vue?vue&type=script&lang=js"
export * from "./CompactPagination.vue?vue&type=script&lang=js"
import style0 from "./CompactPagination.vue?vue&type=style&index=0&id=99561ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99561ca8",
  null
  
)

export default component.exports